import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { getCurrentUser } from "../services/authService";
import { hasFeature } from "../services/features";
import { featureFor } from "../services/routePermissions";

/**
 * A screen whose plan feature is off shows the upgrade note instead of
 * rendering and filling with `403 plan_feature_unavailable`. Like
 * RequirePermission it is a courtesy; the API refuses either way.
 */
export default function RequireFeature({ path, children }) {
  const { t } = useTranslation();
  const feature = featureFor(path);

  if (!feature || hasFeature(getCurrentUser(), feature)) {
    return children;
  }

  return (
    <PlanUpgradeNote>
      <Link to="/" className="btn-secondary mt-5 inline-block">
        {t("permissions.deniedHome")}
      </Link>
    </PlanUpgradeNote>
  );
}

/** The "not in your plan" card, also used inline where a loyalty section would be. */
export function PlanUpgradeNote({ children }) {
  const { t } = useTranslation();

  return (
    <div className="card mx-auto max-w-lg px-6 py-10 text-center">
      <LockClosedIcon className="mx-auto h-8 w-8 text-ink-2" aria-hidden="true" />
      <h2 className="mt-3 text-lg font-semibold">{t("loyalty.upgradeTitle")}</h2>
      <p className="mt-2 text-sm text-ink-2">{t("loyalty.upgradeBody")}</p>
      {children}
    </div>
  );
}
